import { createDefaultApp } from '@/core/main';

createDefaultApp().mount('#app');
